// Import CSS for Vite processing
import '../css/main.css';
import Alpine from 'alpinejs';
import './votes.js';

window.Alpine = Alpine;
Alpine.store('partners', { shuffled: [] });
// Full vote results (categories with items and percentage) for the current locale. Fetched when a vote slide loads.
Alpine.store('voteResults', { categories: [] });
// Current slide index and total count; footer uses this to show only on home (0) and end (totalSlides - 1).
Alpine.store('slide', { currentView: 0, totalSlides: 0 });
Alpine.start();
